import React, { useEffect, useState } from "react";
import "./style.css";
import img from "../../../Assets/SharedStyle/Shoman & Arab Bank - logos - Final-02.png";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LogOutServices from "../../../Services/Account/LogOutServices";
import loadConfig from "../../../Services/Api/ApiServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { setLanguage } from "../../../Redux/Reducers/Shared/language";
import { Accessibility } from "accessibility";

const HeaderManager = (props) => {
  const [dataJsonObject, SetDataJsonObject] = useState();
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);

  const state = useSelector((state) => {
    return {
      UserInfo: state.UserInfo,
    };
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let location = useLocation();
  const ApplicantInformation = useSelector(
    (state) => state.ApplicantInformation.ApplicantInformation
  );

  //get user inormation
  const [userInfo, setUserinfo] = useState({
    ...state.UserInfo?.userToken?.userToken,
  });
  const [lang, setLang] = useState(localStorage.getItem("lang") || "ar");

  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
  };

  //to get data json from main.js
  useEffect(() => {
    dataJson();
  }, []);
  console.log(UserInfo, "ssssssssdwdwdwdwd");
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

    localStorage.setItem("lang", lang);
    dispatch(setLanguage(lang));
  }, [lang]);
  const [accessInstance, setAccessInstance] = useState(null);
  useEffect(() => {
    let access;

    const initAccessibility = () => {
      access = new Accessibility({
        root: document.getElementById("accessibility-root"), // toolbar renders here
        textToSpeechLang: "en-US",
        speechToTextLang: "en-US",
        session: { persistent: true },
        labels:
          lang === "ar"
            ? {
                menuTitle: "خيارات الوصول",
                increaseText: "تكبير الخط",
                decreaseText: "تصغير الخط",
                invertColors: "عكس الألوان",
                increaseTextSpacing: "زيادة تباعد النص",
                decreaseTextSpacing: "تقليل تباعد النص",
                increaseLineHeight: "زيادة ارتفاع السطر",
                decreaseLineHeight: "تقليل ارتفاع السطر",
                grayHues: "تدرجات رمادية",
                underlineLinks: "تسطير الروابط",
                bigCursor: "مؤشر كبير",
                readingGuide: "دليل القراءة",
                textToSpeech: "قراءة النص",
                speechToText: "إملاء صوتي",
                disableAnimations: "إيقاف الحركات",
                reset: "إعادة الضبط",
              }
            : {
                menuTitle: "Accessibility Options",
              },
        modules: {
          decreaseText: true,
          increaseText: true,
          invertColors: true,
          increaseTextSpacing: true,
          decreaseTextSpacing: true,
          increaseLineHeight: true,
          decreaseLineHeight: true,
          grayHues: true,
          underlineLinks: false,
          bigCursor: true,
          readingGuide: false,
          textToSpeech: true,
          speechToText: true,
          disableAnimations: true,
          reset: true,
        },
        icon: {
          useDefault: false, // disable floating icon completely
        },
      });

      setAccessInstance(access);
    };

    if (document.readyState === "complete") {
      initAccessibility();
    } else {
      window.addEventListener("load", initAccessibility);
    }

    return () => {
      if (access && access.menuInterface?.destroy) {
        access.menuInterface.destroy();
      }
      window.removeEventListener("load", initAccessibility);
    };
  }, [lang]);
  // Click handler to open the accessibility menu
  const handleAccessClick = () => {
    if (accessInstance && accessInstance.menuInterface?.open) {
      accessInstance.menuInterface.open();
    }
  };

  useEffect(() => {
    if (lang === "en") {
      // Icon
      document.documentElement.style.setProperty("--_access-icon-left", "10px");
      document.documentElement.style.setProperty(
        "--_access-icon-right",
        "unset"
      );

      // Menu
      document.documentElement.style.setProperty("--_access-menu-left", "10px");
      document.documentElement.style.setProperty(
        "--_access-menu-right",
        "auto"
      );
    } else {
      // Icon
      document.documentElement.style.setProperty(
        "--_access-icon-right",
        "10px"
      );
      document.documentElement.style.setProperty(
        "--_access-icon-left",
        "unset"
      );

      // Menu
      document.documentElement.style.setProperty(
        "--_access-menu-right",
        "10px"
      );
      document.documentElement.style.setProperty("--_access-menu-left", "auto");
    }
  }, [lang]);
  console.log(accessInstance, "accessInstance");

  // useEffect(() => {
  //   const menu = document.querySelector("._access-menu");
  //   if (!menu) return;

  //   // تأكيد الإخفاء الافتراضي
  //   menu.style.display = "none";

  //   const observer = new MutationObserver(() => {
  //     const computedDisplay = window.getComputedStyle(menu).display;

  //     // فقط إذا المكتبة فتحتها → نسمح بالظهور
  //     if (computedDisplay !== "none") {
  //       menu.style.display = "block";
  //     } else {
  //       menu.style.display = "none";
  //     }
  //   });

  //   observer.observe(menu, {
  //     attributes: true,
  //     attributeFilter: ["style", "class"],
  //   });

  //   return () => observer.disconnect();
  // }, []);

useEffect(() => {
  const observer = new MutationObserver(() => {
    const menu = document.querySelector("._access-menu");
    const closeBtn = document.querySelector("._menu-close-btn");

    if (menu && closeBtn && !closeBtn._bound) {
      closeBtn._bound = true;
      closeBtn.addEventListener("click", () => {
        menu.style.display = "none";
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}, []);



  return (
    <div
      className="headerPage"
      style={{
        direction: lang === "ar" ? "rtl" : "ltr",
      }}
    >
      {/* Logo Section */}
      <div className="LogoImageContainer">
        <img className="logoImage" src={img} alt="Logo" />
      </div>

      {/* Icons Section */}
      <div className="IconsContainer">
        {/* User Info */}
        <div
          className="UserIcon"
          //  title={UserInfo?.UserNameEN}
          data-header-tooltip={UserInfo?.UserNameEN}
        >
          <i className="bi bi-people"></i>
        </div>

        {/* Contact Info */}
        {/* <div className="ContactIcons"> */}
        <a
          // title={dataJsonObject?.AwardNumber}
          data-header-tooltip={dataJsonObject?.AwardNumber}
          target="_blank"
          href={`tel:${dataJsonObject?.AwardNumber}`}
        >
          <i className="bi bi-telephone"></i>
        </a>
        <a
          // title={dataJsonObject?.AwardEmail}
          data-header-tooltip={dataJsonObject?.AwardEmail}
          href={`mailto:${dataJsonObject?.AwardEmail}`}
        >
          <i className="bi bi-envelope"></i>
        </a>
        {/* Language Switch */}
        {JSON.parse(UserInfo?.roles)
          ?.map((role) => role.RoleId)
          .includes("1892598f-2e8b-438c-b94d-034fc30091c5") ||
        JSON.parse(UserInfo?.roles)
          ?.map((role) => role.RoleId)
          .includes("ef6254f7-b374-4133-8a71-8b77be6ea5bd") ? (
          <div
            className="LangSwitcher"
            // title={lang === "en" ? "ع" : "en"}
            data-header-tooltip={lang === "en" ? "ع" : "en"}
            onClick={async (r) => {
              if (lang == "ar") {
                setLang("en");
              } else {
                setLang("ar");
              }
              window.location.reload();
            }}
          >
            <FontAwesomeIcon icon={faGlobe} />
          </div>
        ) : (
          ""
        )}
        <div
          className="MyAccessIcon"
          data-header-tooltip={
            lang === "ar" ? "إعدادات الوصول" : "Accessibility"
          }
          onClick={() => {
            const accessButton = document.querySelector("._access-icon");
            const accessMenu = document.querySelector("._access-menu");

            if (!accessButton || !accessMenu) {
              console.warn("Accessibility elements not found");
              return;
            }
            console.log(accessMenu.classList, "classList");
            console.log(accessMenu, "accessMenu");

            

            // trigger original accessibility behavior
            accessButton.click();

            // toggle visibility
            if (
              accessMenu.style.display === "block" &&
              accessMenu.classList.contains("close")
            ) {
              accessMenu.style.display = "none";
            } else {
              accessMenu.style.display = "block";
            }
          }}
        >
          <i className="bi bi-universal-access"></i>
        </div>
        {/* Logout */}
        <div
          className="LogoutIcon"
          // title={lang === "en" ? "Log Out" : "خروج"}
          data-header-tooltip={lang === "en" ? "Log Out" : "خروج"}
          onClick={LogOutServices}
        >
          <i className="bi bi-box-arrow-in-right"></i>
        </div>
      </div>
    </div>
  );
};

export default HeaderManager;
